import { Component, Input, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/blocCommun/mapa/step1';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
import { TypeAdresse } from '../models/TypeAdresse';
import { CTRL_268 } from '../../../validators/268/ctrl268';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-type-adresse',
  templateUrl: './type-adresse.component.html'
})
export class TypeAdresseComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() uid = '';
  @Input() parentForm: FormGroup;
  @Input() adr: TypeAdresse;
  @Input() disabled: boolean;

  public current_uid = 'TypeAdresse';
  public step1 = new Step1();
  public paysCtrlName: string;
	public optionsSelect: any[];
  public optionsSelectType = 'PAYS';
  public rg1 = CTRL_268.id + '_1';
  private destroy$ = new Subject<void>();

	constructor(private autoCompleteService: AutoCompleteService) { }

	public ngOnInit() {

		this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);
    this.paysCtrlName = this.getUid() + '_SepAtt_pays';

    if (!this.adr) {
      this.adr = new TypeAdresse();
    }

    // Convertir null et 'FR' vers '' (code France dans le dropdown PAYS)
    // null est retourné par le backend quand le pays est France
    // '' est le code de l'option "FRANCE" dans la liste déroulante
    if (this.adr.pays === null || this.adr.pays === 'FR') {
      this.adr.pays = '';
    }
  }

  ngAfterViewInit() {
    // Synchroniser le modèle avec le FormControl pour préserver la valeur lors de la navigation entre blocs
    setTimeout(() => {
      const control = this.parentForm.get(this.paysCtrlName);
      if (control) {
        control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
          if (this.adr) {
            this.adr.pays = value;
          }
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  isFr(): boolean {
		if (this.parentForm.controls[this.paysCtrlName]?.value === '' || this.parentForm.controls[this.paysCtrlName]?.value === null || this.parentForm.controls[this.paysCtrlName]?.value === 'FR') {
			this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: this.getCtrl_268Names_json() }));
      return true;
		}
		return false;
	}

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

  private getCtrl_268Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_MAPA_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypeAdresse_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }
}
